<template>
  <UIDropdownSearchList
    :data
    placement="bottom-end"
    @click:item="handleAddOwner"
  >
    <template #default="{ show }">
      <UIButton
        v-tooltip.top="'Move to'"
        variant="gray"
        fill="light"
        size="xs"
        :trailing="ArrowUturnRightIcon"
        class="move-to__button"
        @click="show"
      />
    </template>
  </UIDropdownSearchList>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { uniqBy } from 'lodash'

import { AnalyticsField, DropdownListData } from '@types'

import { ArrowUturnRightIcon } from '@heroicons/vue/24/outline'
import { UIButton } from '@ui/buttons'
import { UIDropdownSearchList } from '@ui/dropdowns'

type Props = {
  data: DropdownListData[]
  path?: string[]
}

type Emits = {
  'select': [value: string]
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const data = computed(() => {
  const assetId = props.path?.at(-1)
  const accountId = props.path?.at(-2)
  if (!assetId || !accountId) {
    return []
  }
  const filtered = props.data
    .filter(item => 
      !props.path || 
      !(item.meta?.path.includes(assetId) || item.meta?.path.at(-1) === accountId) || 
      (item.meta?.path.at(-2) === AnalyticsField.REPO_ROOT && item.meta?.path.at(-1) !== assetId)
    )
  return uniqBy(filtered, 'value')
})

const handleAddOwner = (value?: string) => {
  if (!value) return
  emit('select', value)
}
</script>

<style>
.move-to__button {
  @apply rotate-180;
}
</style>
